import React from 'react';
import {Provider} from "react-redux";
import configure from "../../store/configure";
import JoinAgreeContainer from "./container/JoinAgreeContainer";

const JoinAgreePage = () => {
    const searchParams = new URLSearchParams(window.location.search);

    /* 쿼리파라미터 또는 세션스토리지에서 호스팅사 유입 회원 식별 */
    let hstate = searchParams.get("hstate");
    if(!hstate) hstate = window.sessionStorage.getItem('hstate');

    return (
        <Provider store={configure}>
            <JoinAgreeContainer hstate={hstate}/>
        </Provider>
    )
};

export default JoinAgreePage;
